import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { Table } from "react-bootstrap";
import moment from "moment";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Row from "react-bootstrap/Row";
import Accordion from "react-bootstrap/Accordion";
// import SeatingDashboardLeft from "./../MainAllPagesLink";
// import { SeatingDashboardRight } from "./../../../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/SeatingDashboardRight";
import { SeatingStatus } from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";
import TableSizePopup from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import SetWaitTimeSuperAdmin from "../popup/SetWaitTimeSuperAdmin";
import StatusChangeAction from "../popup/StatusChangeAction";
import Filter from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import { SeatingDashboardMobile } from "../../../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardMobile";
import {
  SeatingDashboardDesktopTableHead,
  SeatingDashboardTableManagement,
} from "../../../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardDesktopTableHead";
import { SuperAdminSeatingTableBody } from "../TableBody/SuperAdminSeatingTableBody";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import {
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
  get_all_vendor_reservation_information,
  get_all_vendor_history_information,
} from "../../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import isEmpty from "../../../../../../store/validation/is-Empty";
import store from "../../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../../store/types";

// import { serverApi } from "../../../../config/Keys";

// import feathers from "@feathersjs/client";
// import socketio from "@feathersjs/socketio-client";

// const feathers = require("@feathersjs/client");
// const socketio = require("@feathersjs/socketio-client");

if (!global._babelPolyfill) {
  require("babel-polyfill");
}

const totalRecordsInOnePage = 50;

export class SeatingScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPagination: 1,
      displayGrid: false,
      displayDropDown: false,
      allDinerDetails: [],
      displayMobileSearch: false,
      displaySearch: false,
      open: false,
      openDefaultWaitTime: false,
      openPax: false,
      selectedPage: 1,
      showStatus: "All",
      showStatusText: "",
      defaultWaitTime: "00-05",
      showPax: "All",
      showPaxText: "",
      search: "",
      loader: false,
      hasSetUpdate: false,
      newData: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.allDinnerDetails) !== nextState.allDinerDetails) {
      return {
        allDinerDetails: nextProps.allDinnerDetails,
      };
    }
    if (!isEmpty(nextProps.auth.loader) !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data && !this.state.hasSetUpdate) {
      this.props.get_all_vendor_seating_information(this.props.data);
      this.props.get_all_vendor_pending_information(this.props.data);
      this.props.get_all_vendor_reservation_information(this.props.data);
      this.props.get_all_vendor_history_information(this.props.data);
      // this.setState({
      //   newData: this.props.data,
      //   hasSetUpdate: true,
      // });
      store.dispatch({
        type: SET_VENDOR_INFORMATION,
        payload: this.props.data,
      });
    }
    return null;
  }

  // onGridViewOpen = (e) => {
  //   this.setState({
  //     displayGrid: !this.state.displayGrid,
  //   });
  // };

  onNextHoursOpen = (e) => {
    this.setState({
      displayDropDown: !this.state.displayDropDown,
    });
  };

  /****************************************
   * @DESC Ope Modal
   ***************************************/
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  /****************************************
   * @DESC Big Button Show Status Handler
   ***************************************/
  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatusText: type,
    });
  };
  selectStatusClick = (e) => {
    this.setState({
      showStatus:
        this.state.showStatusText === "" ? "All" : this.state.showStatusText,
      open: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPaxText: type,
    });
  };
  selectPaxClick = (e) => {
    console.log("hi");
    this.setState({
      showPax: this.state.showPaxText === "" ? "All" : this.state.showPaxText,
      openPax: false,
    });
  };

  searchButton = (e) => {
    e.preventDefault();
    this.setState({
      displaySearch: true,
    });
  };

  searchButtonClose = (e) => {
    e.preventDefault();
    this.setState({ displaySearch: false });
  };

  searchButtonMobile = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: true,
    });
  };

  searchButtonMobileClose = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: false,
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  onChangePagination = (page) => {
    this.setState({
      currentPagination: page,
    });
  };

  /****************************************
   * @DESC Seating Desktop View Components
   ***************************************/
  renderSeatingCardView = () => {
    const { allDinerDetails, showPax, currentPagination } = this.state;
    // console.log(allDinerDetails);
    let filtereddata = [];
    if (showPax === "All" && this.state.showStatus === "All") {
      filtereddata = allDinerDetails;
    } else if (this.state.showPax === "8>") {
      filtereddata = allDinerDetails.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (this.state.showPax === "8") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "6") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "4") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "2") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (this.state.showStatus === "Not Seated") {
      filtereddata = allDinerDetails.filter(
        (dinner) => dinner.diner_status === "NOTSEATED"
      );
    }
    if (this.state.showStatus === "Seated") {
      filtereddata = allDinerDetails.filter(
        (dinner) => dinner.diner_status === "SEATED"
      );
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = allDinerDetails.filter((getall) => {
        if (search.test(getall.user_details.name)) {
          return getall;
        } else if (
          search.test(
            getall.user_details.country_code + getall.user_details.mobile_number
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment key={index}>
              <SuperAdminSeatingTableBody
                dinerInfo={data}
                dinerName={data.user_details.name}
                displayCall={true}
                displaySms={true}
                displayNotification={true}
                displayChat={true}
                displayViewDiner={true}
                displayEditDiner={true}
                sendDataDinerProps={data}
              />
            </React.Fragment>
          )
      );
    } else {
      return null;
    }
  };

  /****************************************
   * @DESC Seating Mobile View Components
   ***************************************/
  renderSeatingAccordian = () => {
    const { allDinerDetails, showPax } = this.state;
    let filtereddata = [];
    if (showPax === "All" && this.state.showStatus === "All") {
      filtereddata = allDinerDetails;
    } else if (this.state.showPax === "8>") {
      filtereddata = allDinerDetails.filter(
        (dinner) => dinner.adult_count + dinner.kids_count >= 8
      );
    } else if (this.state.showPax === "8") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 7 &&
          dinner.adult_count + dinner.kids_count <= 8
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "6") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 5 &&
          dinner.adult_count + dinner.kids_count <= 6
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "4") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 3 &&
          dinner.adult_count + dinner.kids_count <= 4
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    } else if (this.state.showPax === "2") {
      filtereddata = allDinerDetails.filter((dinner) => {
        if (
          dinner.adult_count + dinner.kids_count >= 0 &&
          dinner.adult_count + dinner.kids_count <= 2
        ) {
          return dinner;
        } else {
          return false;
        }
      });
    }
    if (this.state.showStatus === "Not Seated") {
      filtereddata = allDinerDetails.filter(
        (dinner) => dinner.diner_status === "NOTSEATED"
      );
    }
    if (this.state.showStatus === "Seated") {
      filtereddata = allDinerDetails.filter(
        (dinner) => dinner.diner_status === "SEATED"
      );
    }
    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata = allDinerDetails.filter((getall) => {
        if (search.test(getall.user_details.name)) {
          return getall;
        } else if (
          search.test(
            getall.user_details.country_code + getall.user_details.mobile_number
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }
    //  else {
    //   filtereddata = allDinerDetails;
    // }
    if (!isEmpty(filtereddata)) {
      return filtereddata.map((data, index) => (
        <React.Fragment key={index}>
          <SeatingDashboardMobile
            indexKey={index}
            dinnerId={`#${data.diner_id}`}
            dinnerOrderType={"waitlist"}
            dinnerName={data.user_details.name}
            totalCount={data.adult_count + data.kids_count}
            totalAdult={data.adult_count}
            totalKids={data.kids_count}
            totalHighchair={data.high_chair}
            totalHandicapped={data.handicap_chair}
            displayLocation={false}
            date={moment(data.createdAt).format("hh:mm A")}
            time={moment(data.createdAt).format("Do MMM YYYY")}
            displayButton={data}
            seatingPreference={data.seating_preference}
            displayButtonTwo={data}
            displayCall={true}
            displaySms={true}
            displayNotification={true}
            displayViewDiner={true}
            tableNo={
              data.table_number === null || data.table_number === undefined
                ? ""
                : data.table_number
            }
            roomNo={data.room_number}
            specialOcassion={data.occasion}
            status={data.diner_status}
            sendDataDinerProps={data}
          />
        </React.Fragment>
      ));
    } else {
      return null;
    }
  };

  render() {
    const { displayGrid, displayDropDown } = this.state;
    if (this.props.auth.loader === true) {
      return <AmealioLoader />;
    } else {
      // const seatingImage = require("../../../../../../assets/images/seatingImages/chairWhite.png");
      return (
        <React.Fragment>
          <Container fluid>
            <div className="w-100">
              <hr />
            </div>
            <Row>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 seating-topbar-search">
                <div className="filter-button">
                  <Filter />
                </div>
                <div className="filter-button-border-left"></div>
                <div className="filter-button-search">
                  <Paper
                    component="form"
                    style={{ border: "1px solid #E0E0E0" }}
                  >
                    <IconButton type="submit" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      placeholder="Search"
                      inputProps={{
                        "aria-label": "Search by Name or Phone Number",
                      }}
                      onChange={this.onSearchChange}
                      value={this.state.search}
                    />
                  </Paper>
                </div>
                <div className="filter-button-qrcode">
                  <div className="filter-button-qrcode-box">
                    <img
                      src={require("../../../../../../assets/images/ActionImages/image/qrcode.svg")}
                      className="img-fluid"
                      alt="QR Scan"
                      title="QR Scan"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <div className="row">
                  <div className="col-5 col-sm-5 col-md-4 col-lg-4 col-4">
                    <SeatingStatus
                      status={this.state.showStatus}
                      onOpenModal={this.onOpenModal}
                      onCloseModal={this.onCloseModal}
                      open={this.state.open}
                      seatingStatus={this.state.showStatusText}
                      onClickAll={(e) =>
                        this.bigButtonShowStatusHandler(e, "All")
                      }
                      onClickSeated={(e) =>
                        this.bigButtonShowStatusHandler(e, "Seated")
                      }
                      onClickNonSeated={(e) =>
                        this.bigButtonShowStatusHandler(e, "Not Seated")
                      }
                      onStatusClick={this.selectStatusClick}
                    />
                  </div>
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-4">
                    <SetWaitTimeSuperAdmin data={this.props.data} />
                  </div>
                  <div className="col-3 col-sm-3 col-md-4 col-lg-4 col-4">
                    <TableSizePopup
                      showPax={this.state.showPax}
                      onOpenModal={this.onOpenModalPax}
                      open={this.state.openPax}
                      onCloseModal={this.onCloseModalPax}
                      table_size={this.state.showPaxText}
                      onClickAll={(e) => this.bigButtonShowPaxHandler(e, "All")}
                      onClickTwo={(e) => this.bigButtonShowPaxHandler(e, "2")}
                      onClickFour={(e) => this.bigButtonShowPaxHandler(e, "4")}
                      onClickSix={(e) => this.bigButtonShowPaxHandler(e, "6")}
                      onClickEight={(e) => this.bigButtonShowPaxHandler(e, "8")}
                      graterThanEight={(e) =>
                        this.bigButtonShowPaxHandler(e, "8>")
                      }
                      selectPaxClick={this.selectPaxClick}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 right-side-seating">
                <div className="complete_record_image">
                  <StatusChangeAction
                    display={true}
                    displayPopup="completedRecord"
                    buttonDisplay="completedRecord"
                    buttonText="Complete Record"
                    bigText="Are you sure to Complete All Seated Records ?"
                    dataSend={this.props.data}
                  />
                  <p className="complete_record_small_text">
                    Mark Seated as Complete
                  </p>
                </div>
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    className={
                      displayGrid
                        ? "btn grid-button-group"
                        : "btn grid-button-group grid-button-group-active"
                    }
                    onClick={this.onGridViewOpen}
                  >
                    <img
                      src={require("../../../../../../assets/images/ActionImages/image/grid.svg")}
                      className="img-fluid"
                      alt="table"
                      title="table"
                    />
                  </button>
                  <button
                    type="button"
                    className={
                      displayGrid
                        ? "btn grid-button-group grid-button-group-active"
                        : "btn grid-button-group"
                    }
                    onClick={this.onGridViewOpen}
                  >
                    <img
                      src={require("../../../../../../assets/images/ActionImages/image/table.svg")}
                      className="img-fluid"
                      alt="table"
                      title="table"
                    />
                  </button>
                </div>
              </div>
            </Row>

            {/*******************************
             *  @DESC Seating Desktop View
             *******************************/}
            <div className="row mt-4">
              <div
                className={displayGrid === true ? "col-7 p-0" : "col-12 p-0"}
              >
                <div className="col-12">
                  <div className="seating-dashboard-desktop-table">
                    <Table>
                      <SeatingDashboardDesktopTableHead
                        displayGridProps={displayGrid}
                      />
                    </Table>
                  </div>
                </div>
                {displayGrid ? null : (
                  <div className="col-12 today-date-dropdown-seating-dashboard">
                    <div>
                      <h4>Today, {moment().format("Do MMM YYYY")}</h4>
                    </div>
                    <div className="seating-dashboard-today-line">
                      <hr className="line" />
                    </div>
                  </div>
                )}
                {displayGrid ? null : (
                  <div className="col-12 mb-4">
                    <div className="seating-dashboard-next-hours">
                      <div
                        className="dropdown_box b_c_red"
                        onClick={this.onNextHoursOpen}
                      >
                        {displayDropDown ? (
                          <i
                            className="fa fa-angle-up c_white"
                            aria-hidden="true"
                          ></i>
                        ) : (
                          <i
                            className="fa fa-angle-down c_white"
                            aria-hidden="true"
                          ></i>
                        )}
                      </div>
                      <h5 className="font_20_m c_red ml-3">
                        With-in next hour
                      </h5>
                    </div>
                  </div>
                )}
                <div className="col-12 seating-dashboard-body-width">
                  <Table>{this.renderSeatingCardView()}</Table>
                </div>
              </div>
              <div
                className={
                  displayGrid === true
                    ? "col-5 seating-right-side-boxcount p-0"
                    : "d-none"
                }
              >
                <div className="col-12">
                  <div className="seating-dashboard-desktop-table">
                    <Table>
                      <SeatingDashboardTableManagement />
                    </Table>
                  </div>
                </div>
              </div>
            </div>

            {/*******************************
             *  @DESC Seating Mobile View
             *******************************/}
            <div className="row seating-dashboard-table">
              <div className="col-5">
                <p className="top-heading-text">Name</p>
              </div>
              <div className="col-4">
                <p className="top-heading-text">Total</p>
              </div>
              <div className="col-3">
                <p className="top-heading-text">Status</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-0">
                <Accordion>{this.renderSeatingAccordian()}</Accordion>
              </div>
            </div>
            <div className="p4v2-menu-pagination">
              <Pagination
                onChange={this.onChangePagination}
                current={this.state.currentPagination}
                defaultPageSize={totalRecordsInOnePage}
                total={
                  !isEmpty(this.state.allDinerDetails)
                    ? this.state.allDinerDetails.length
                    : 0
                }
                showTitle={false}
              />
            </div>
          </Container>
        </React.Fragment>
      );
    }
  }
}

SeatingScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allDinnerDetails: state.adminAllVendorsInfo.superAdminGetSeatingVendorDiner,
  allPendingDiners: state.adminAllVendorsInfo.superAdminGetPendingVendorDiner,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
  get_all_vendor_reservation_information,
  get_all_vendor_history_information,
})(withRouter(SeatingScreen));
